import api from './api';

export function getGeojson(camada) {
  return api.get(`/geojson/${camada}`);
}

export function salvarGeom(camada, params) {
  return api.post(`/geojson/${camada}`, params);
}
